import { HospitalValidInfoEntity } from "@/domain/entity/hospital-valid-info-entity";
import { HospitalInfoValidResponseDto } from "../dto/hospital-info-valid-reponse-dto";
import { assertHospitalInfoValidResponseDto } from "@/utils/validation/generated/hospital-info-valid-response-dto.validator";

export class HospitalInfoValidMapper {
  static toEntity(dto: HospitalInfoValidResponseDto): HospitalValidInfoEntity {
    assertHospitalInfoValidResponseDto(dto);

    return {
      isValid: dto.isValide,
      name: dto.hospitalName,
    };
  }
}
